import { PlanType } from '@labrav/react-components'
import { FormField } from '@labrav/react-components/lib/@types/types/forms'
import { isEmpty } from 'lodash'

export const planTypesForCommonFields = [
  PlanType.SAAS_CONTRACT,
  PlanType.PROFESSIONAL_SERVICES,
]

export const getInstallmentsKeyName = (isResale: boolean) =>
  isResale ? 'installmentInfo' : 'installments'

export const getInstallmentAmountValue = (value: string) =>
  value !== '' ? Number(value) : value

export const createPaymentDateField = (paymentDate?: string): FormField => ({
  title: 'Date',
  humanReadableKey: 'Date',
  placeHolder: 'Date',
  id: 'paymentDate',
  isRequired: true,
  isReadOnly: false,
  isCustom: false,
  defaultValue: !isEmpty(paymentDate) ? paymentDate : undefined,
  dataType: 'date',
  minDate: 'today',
})

export const pricingTooltipLabel = `Note:
          1. There cannot be a payment date before expiration date.
          2. The payment date cannot be after the validity date, where validity date = today's date + contract duration.
          3. There cannot be duplicate payment date.`
